export const promissoryStatusQuery = {
  1: 'Registrado',
  2: 'Aprobado',
  3: 'Rechazado',
  4: 'Anulado',
  5: 'Temporal'
};
